<script>
  import { onMount, onDestroy } from 'svelte';
  import { navigate } from 'svelte-routing';
  import Conexoes from '../Classes/Conexoes.js';
  import Constantes from '../Classes/Constantes.js';
  import { tenantLogado } from '../Classes/Stores.js';
  import LoadingTela from '../componentes_basicos/LoadingTela.svelte';
  import CaixaDeDialogo from '../componentes_basicos/CaixaDeDialogo.svelte';
  import AbaTutorial from './componentes_painel/AbaTutorial.svelte';
  import AbaLocais from './componentes_painel/AbaLocais.svelte';
  import Sidebar from './componentes_painel/Sidebar.svelte';
  import AbaGerarHorarios from './componentes_painel/AbaGerarHorarios.svelte';
  import AbaHorariosAbertos from './componentes_painel/AbaHorariosAbertos.svelte';
  import AbaAgendamentos from './componentes_painel/AbaAgendamentos.svelte';
  import AbaConfiguracoes from './componentes_painel/AbaConfiguracoes.svelte';
  import AbaPerfil from './componentes_painel/AbaPerfil.svelte';
  import AbaConfigCampos from './componentes_painel/AbaConfigCampos.svelte';
  import AbaCreditos from './componentes_painel/AbaCreditos.svelte';
  import AbaPersonalizar from './componentes_painel/AbaPersonalizar.svelte';
  import AbaIndicacao from './componentes_painel/AbaIndicacao.svelte';
  $: tenant = $tenantLogado;
  const conexao = new Conexoes();
  
  let isLoading = false;
  let mensagem = '';
  let agendamentos = [];
  let horarios = [];
  let locais = [];
  let mostrarQrCode = false;
  let ultimaAba = null;

  // 1. MEMÓRIA DA ABA: Tenta ler do URL primeiro, senão lê do localStorage, senão usa 'horarios'
  const urlParams = new URLSearchParams(window.location.search);
  let abaAtiva = urlParams.get('aba') || localStorage.getItem('ultimaAbaFitpace') || 'horarios';
// Cria uma variável reativa. Toda vez que o 'tenant' mudar, o Svelte recalcula isso sozinho.
  $: contaBloqueada = tenant ? (tenant.ativo === 0 || tenant.dias_restantes <= 0) : false;

  // Atualize ou crie a sua função de trocar de aba para respeitar o bloqueio:
  function mudarAba(novaAba) {
    // Se a conta estiver bloqueada e ele tentar acessar abas restritas, nós impedimos
    if (contaBloqueada && novaAba !== 'creditos' && novaAba !== 'indicacao') {
      alert("Realize o pagamento da sua assinatura para liberar este recurso.");
      abaAtual = 'creditos';
      return;
    }
    abaAtual = novaAba;
  }
  // Sempre que a abaAtiva mudar, guarda no localStorage e atualiza a URL silenciosamente
  $: {
    if (abaAtiva) {
      localStorage.setItem('ultimaAbaFitpace', abaAtiva);
      window.history.replaceState(null, '', '?aba=' + abaAtiva);
    }
  }

  $: if (abaAtiva !== ultimaAba) {
    if (abaAtiva === 'agendamentos' && ultimaAba !== 'agendamentos') {
      void carregarDados(true);
    }
    ultimaAba = abaAtiva;
  }

  $: linkPublico = tenant ? `${window.location.origin}/agendar/${tenant.slug}` : '';
  $: qrCodeUrl = linkPublico ? `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(linkPublico)}&color=4a6c56` : '';

  let intervalId;

  onMount(async () => {
    if (!tenant) { navigate(Constantes.tela_login); return; }
    
    if (urlParams.get('google') === 'success') {
      mensagem = "✅ Google Agenda ligado com sucesso!";
      abaAtiva = 'configuracoes';
      window.history.replaceState({}, document.title, window.location.pathname);
    }
    
    // Carregamento inicial (com tela de loading)
    await carregarDados(false);

    // 2. ATUALIZAÇÃO EM TEMPO REAL: Atualiza a cada 30 segundos (30000ms) de forma silenciosa
    intervalId = setInterval(() => {
      carregarDados(true);
    }, 30000);
  });

  // Limpa o cronômetro se o utilizador sair deste componente (boa prática de memória)
  onDestroy(() => {
    if (intervalId) clearInterval(intervalId);
  });

  // Alterado para aceitar o parâmetro 'silencioso'
  async function carregarDados(silencioso = false) {
   
    if (!silencioso) isLoading = true; // Só mostra o loading giratório se NÃO for silencioso
     if (!tenant) return;
    const api_obter = Constantes.api_acesso.replace('acesso.php', 'obter_tenant.php');
    const urlLocais = Constantes.api_acesso.replace('acesso.php', 'listar_locais.php');
    
    // Fazemos todas as requisições em paralelo para ser mais rápido
    const [resPerfil, resH, resA, resL] = await Promise.all([
      conexao.conecta(api_obter, { body: { id_tenant: tenant.id } }),
      conexao.conecta(Constantes.api_listar_horarios, { body: { id_tenant: tenant.id, admin: true } }),
      conexao.conecta(Constantes.api_listar_agendamentos, { body: { id_tenant: tenant.id } }),
      conexao.conecta(urlLocais, { body: { id_tenant: tenant.id } })
    ]);

    if (resPerfil?.sucesso) {
      tenantLogado.set(resPerfil.tenant);
      tenant = resPerfil.tenant;
    }

    horarios = resH || [];
    agendamentos = resA || [];
    locais = resL || [];
    if (!silencioso) isLoading = false;
if (tenant.ativo === 0 || tenant.dias_restantes <= 0) {
        abaAtual = 'creditos'; // Força a renderização do <AbaCreditos />
    }
    
  }

  // Ações forçadas pelo utilizador
  function handleRecarregar(event) {
    if (event.detail) mensagem = event.detail;
    carregarDados(false); // Quando ele clica em botões, queremos mostrar o loading
  }
  
  function handleLoading(event) {
    isLoading = event.detail;
  }

  async function baixarQrCode() {
    const response = await fetch(qrCodeUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `agenda_${tenant.slug}.png`;
    a.click();
  }

  
</script>

<svelte:head>
  <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&display=swap" rel="stylesheet">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css">
</svelte:head>

<LoadingTela {isLoading} />
<CaixaDeDialogo message={mensagem} button1Label="Ok" button1Action={() => mensagem = ''} />
{#if tenant && tenant.status_ultimo_pagamento === 'pending'}
  <div class="banner-alerta pending" style="background: #fff3cd; color: #856404; padding: 12px; text-align: center; font-weight: bold;">
    <i class="fas fa-exclamation-triangle"></i> Você tem uma fatura PIX pendente. <a href="#" on:click={() => abaAtiva = 'creditos'}>Pagar agora</a>
  </div>
{/if}
{#if tenant && (tenant.ativo === 0 || tenant.dias_restantes <= 0)}
  <div style="background: #e53e3e; color: white; padding: 12px; text-align: center; font-weight: bold; border-radius: 8px; margin-bottom: 20px;">
    <i class="fas fa-exclamation-triangle"></i> Sua agenda está inativa. Realize o pagamento inicial abaixo para liberar o seu link para os clientes!
  </div>
{/if}
{#if tenant && tenant.dias_restantes <= 3}
  <div class="banner-alerta danger" style="background: #f8d7da; color: #721c24; padding: 12px; text-align: center; font-weight: bold;">
    <i class="fas fa-clock"></i> Sua licença expira em {tenant.dias_restantes} dias! <a href="#" on:click={() => abaAtiva = 'creditos'}>Renovar</a>
  </div>
{/if}
{#if mostrarQrCode}
  <div class="modal-overlay fade-in" on:mousedown={() => mostrarQrCode = false}>
    <div class="modal-card" on:mousedown|stopPropagation>
      <button class="close-btn" on:click={() => mostrarQrCode = false}><i class="fas fa-times"></i></button>
      <h3>Partilhar Agenda</h3>
      <div class="qr-container"><img src={qrCodeUrl} alt="QR Code" /></div>
      <button class="btn-primary w-100" on:click={baixarQrCode}><i class="fas fa-download me-2"></i> Baixar PNG</button>
    </div>
  </div>
{/if}

<div class="admin-layout">
  
  <Sidebar bind:abaAtiva horariosCount={horarios.length} agendamentosCount={agendamentos.length} />

  <main class="main-content">
    <header class="top-bar">
      <div class="link-banner">
        <div class="link-text">
          <i class="fas fa-link"></i><span>Agenda:</span><a href={linkPublico} target="_blank">{linkPublico}</a>
        </div>
        <div class="link-actions">
          <button on:click={() => { navigator.clipboard.writeText(linkPublico); mensagem = 'Copiado!'; }}><i class="far fa-copy"></i></button>
          <button on:click={() => mostrarQrCode = true}><i class="fas fa-qrcode"></i></button>
        </div>
      </div>
    </header>

    <div class="view-container">
    {#if abaAtiva === 'locais'}
  <AbaLocais {locais} on:loading={handleLoading} on:recarregar={handleRecarregar} />
{/if}  
     {#if abaAtiva === 'horarios'}
        <AbaGerarHorarios {locais} on:loading={handleLoading} on:recarregar={handleRecarregar} on:mudarAba={(e) => abaAtiva = e.detail} />
      {/if}

      {#if abaAtiva === 'disponiveis'}
        <AbaHorariosAbertos {horarios} on:loading={handleLoading} on:recarregar={handleRecarregar} />
      {/if}

     {#if abaAtiva === 'agendamentos'}
        <AbaAgendamentos {agendamentos} {horarios} on:loading={handleLoading} on:recarregar={handleRecarregar} />
      {/if}
      {#if abaAtiva === 'creditos'}
        <AbaCreditos {tenant} on:recarregar={handleRecarregar} on:loading={handleLoading} />
      {/if}
      {#if abaAtiva === 'indicacao'}
        <AbaIndicacao />
      {/if}
{#if abaAtiva === 'config_campos'}
        <AbaConfigCampos on:loading={handleLoading} />
      {/if}
      {#if abaAtiva === 'configuracoes'}
        <AbaConfiguracoes on:loading={handleLoading} on:recarregar={handleRecarregar} />
      {/if}
       {#if abaAtiva === 'personalizar'}
        <AbaPersonalizar on:loading={handleLoading} on:recarregar={handleRecarregar} />
      {/if}
      {#if abaAtiva === 'perfil'}
  <AbaPerfil on:loading={handleLoading} on:recarregar={handleRecarregar} />
{/if}
 
      {#if abaAtiva === 'tutorial'}
  <AbaTutorial on:loading={handleLoading} on:recarregar={handleRecarregar} />
{/if}
    </div>
  </main>
</div>

<style>
  :root {
    --primary: #4a6c56;
    --primary-dark: #3a5443;
    --secondary: #d4e0d7;
    --accent: #cfaa6c;
    --bg-app: #f4f7f5;
    --sidebar-w: 260px;
    --text: #2c3e34;
    --border: #e2e8e4;
  }

  * { box-sizing: border-box; }
  .admin-layout { display: flex; height: 100vh; background: var(--bg-app); font-family: 'Montserrat', sans-serif; color: var(--text); overflow: hidden; }

  /* CONTENT e LAYOUT GERAL */
  .main-content { flex: 1; display: flex; flex-direction: column; overflow-y: auto; }
  .top-bar { padding: 20px 40px; background: white; border-bottom: 1px solid var(--border); }
  .link-banner { background: var(--primary); color: white; padding: 12px 20px; border-radius: 10px; display: flex; justify-content: space-between; align-items: center; }
  .link-text { font-size: 0.85rem; display: flex; align-items: center; gap: 8px; }
  .link-text a { color: var(--accent); font-weight: 700; text-decoration: none; }
  .link-actions { display: flex; gap: 10px; }
  .link-actions button { background: rgba(255,255,255,0.15); border: none; color: white; padding: 6px 10px; border-radius: 6px; cursor: pointer; }

  .view-container { padding: 30px 40px; max-width: 1100px; }

  /* ESTILOS PARTILHADOS PELOS FILHOS (Usando :global para afetar os componentes injetados) */
  :global(.card-panel) { background: white; padding: 30px; border-radius: 16px; box-shadow: 0 4px 20px rgba(0,0,0,0.03); border: 1px solid var(--border); margin-bottom: 30px; }
  :global(.card-panel h2) { margin: 0 0 25px 0; font-size: 1.3rem; color: var(--primary); font-weight: 800; }
  
  :global(.input-app) { width: 100%; padding: 12px; border: 1px solid var(--border); border-radius: 8px; background: var(--bg-app); font-family: inherit; }
  :global(label) { display: block; font-weight: 700; font-size: 0.85rem; margin-bottom: 8px; color: var(--text); }
  :global(.btn-primary) { background: var(--primary); color: white; border: none; padding: 14px 25px; border-radius: 8px; font-weight: 700; cursor: pointer; transition: 0.3s; }
  :global(.btn-primary:hover) { background: var(--primary-dark); }
  :global(.btn-del) { background: #fff5f5; border: none; color: #e53e3e; padding: 8px; border-radius: 6px; cursor: pointer; }
  
  :global(.table-scroll) { width: 100%; overflow-x: auto; }
  :global(.app-table) { width: 100%; border-collapse: collapse; text-align: left; }
  :global(.app-table th) { padding: 15px; border-bottom: 2px solid var(--border); font-size: 0.8rem; color: #888; text-transform: uppercase; }
  :global(.app-table td) { padding: 15px; border-bottom: 1px solid var(--border); font-size: 0.9rem; }
  :global(.badge-type) { padding: 4px 10px; border-radius: 12px; font-size: 0.75rem; font-weight: 700; background: #eef5f0; color: var(--primary); }
  :global(.badge-type.online) { background: #e3f2fd; color: #1976d2; }
  :global(.wa-link) { color: #25d366; font-weight: 700; text-decoration: none; }
  :global(.text-muted) { color: #777; }

  /* MODAL QR CODE */
  .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); backdrop-filter: blur(4px); z-index: 1000; display: flex; align-items: center; justify-content: center; }
  .modal-card { background: white; padding: 30px; border-radius: 20px; width: 100%; max-width: 360px; position: relative; text-align: center; }
  .close-btn { position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 1.2rem; cursor: pointer; color: #999; }
  .qr-container { background: #f9f9f9; padding: 20px; border-radius: 12px; margin: 20px 0; border: 2px dashed #ddd; }
  .qr-container img { width: 100%; max-width: 220px; border-radius: 8px; }

  /* UTILS */
  :global(.fade-in) { animation: fadeIn 0.3s ease-out; }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: translateY(0); } }
  :global(.mt-2) { margin-top: 10px; } :global(.mt-3) { margin-top: 15px; } :global(.mt-4) { margin-top: 30px; } :global(.mb-3) { margin-bottom: 15px; } :global(.w-25) { width: 25% !important; } :global(.w-50) { width: 50% !important; } :global(.w-100) { width: 100% !important; }

  @media (max-width: 900px) {
    .admin-layout { flex-direction: column; }
    .main-content { overflow-x: hidden; }
    .top-bar { padding: 15px 20px; }
    .view-container { padding: 20px; }
    .link-banner { flex-direction: column; gap: 10px; text-align: center; align-items: flex-start; }
    .link-text { flex-direction: column; align-items: flex-start; gap: 6px; }
    .link-text a { word-break: break-word; }
    .link-actions { width: 100%; justify-content: flex-end; flex-wrap: wrap; }
  }

  @media (max-width: 640px) {
    .top-bar { padding: 12px 16px; }
    .view-container { padding: 16px; }
    .link-banner { padding: 14px; }
    .modal-card { padding: 20px 16px; }
    .qr-container img { max-width: 180px; }
  }
</style>